export default __webpack_public_path__ + "static/media/2-1.fa9dae9c.png";